module.exports = __webpack_public_path__ + "static/media/Slide14.a6fd26e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide14.png
// module id = 1636
// module chunks = 0